import { isJson } from "../../utils";
import Link from "next/link";
import style from "./index.css";

export const currency = (number) =>
  new Intl.NumberFormat({ style: "currency", currency: "NGN" }).format(number);

const sortByName = (a, b) => {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
};

const Table = ({ offers, product, changePlan, selectedOffer, trial }) => {
  const lastOfferData = offers[offers.length - 1];
  let allServiceFeatures = lastOfferData ? lastOfferData.modules : [];
  allServiceFeatures = allServiceFeatures.sort(sortByName);
  return (
    <>
      <div className="table-features product-pricing">
        <table>
          <thead>
            <tr>
              {offers && offers.length > 0 && (
                <th className="head-features top-left-border-radius ">
                  <span className="pick">
                    Pick a plan{" "}
                    <img src="/static/img/icons/arrow-right.svg" alt="" />
                  </span>
                  <span>Features</span>
                </th>
              )}
              {offers &&
                offers.map((offer, idx) => (
                  <PriceTableHead
                    offer={offer}
                    key={idx}
                    product={product}
                    changePlan={changePlan}
                    selectedOffer={selectedOffer}
                    trial={trial}
                  />
                ))}
            </tr>
          </thead>
          <tbody>
            {allServiceFeatures &&
              allServiceFeatures.length > 0 &&
              allServiceFeatures.map((feature, index) => (
                <tr key={index}>
                  <td>
                    <p className="product-feature __tooltip">
                      {feature.name}{" "}
                      {feature.description && (
                        <>
                          <i className="fas fa-info"></i>
                          <i className="fas fa-caret-up"></i>
                          <span>{feature.description}</span>
                        </>
                      )}
                    </p>
                  </td>
                  {offers &&
                    offers.map((offer, idx) => (
                      <TableFeaturesMark
                        offer={offer}
                        key={idx}
                        allServiceFeatures={allServiceFeatures}
                        featuresIndex={index}
                      />
                    ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <style jsx>{style}</style>
    </>
  );
};

const PriceTableHead = ({
  offer,
  product,
  changePlan,
  selectedOffer,
  trial,
}) => {
  const properties =
    offer && isJson(offer.properties) ? isJson(offer.properties) : null;
  const monthlySubscription =
    offer &&
    (offer.subscriptionType == "PERIODIC" ||
      offer.subscriptionType == "ONE_OFF" ||
      offer.subscriptionType == "PER_USER") &&
    offer.activeSubscriptions.length > 0
      ? offer.activeSubscriptions.find((value) => value.period == "MONTHLY")
        ? offer.activeSubscriptions.find((value) => value.period == "MONTHLY")
        : offer.activeSubscriptions[0]
      : offer.subscriptionType == "PER_TRANSACTION"
      ? offer.activeSubscriptions[0]
      : null;
  return (
    <th className={`plan-head-desc`}>
      <div
        className={`plan-head-desc-inner ${
          offer.isRecommended ? "featured" : ""
        }`}
      >
        {offer.isRecommended && !changePlan && (
          <span className="badge-status">popular</span>
        )}
        <p className="plan-type">{offer.name}</p>
        {(offer.subscriptionType == "PERIODIC" ||
          offer.subscriptionType == "PER_USER") &&
          monthlySubscription && (
            <p className="plan-desc">{monthlySubscription.period}</p>
          )}
        {offer.subscriptionType == "ONE_OFF" && (
          <p className="plan-desc"> One Off</p>
        )}
        {offer.subscriptionType === "PER_TRANSACTION" && (
          <p className="price">
            {monthlySubscription &&
              (monthlySubscription.percentageTransactionCharge
                ? ` ${monthlySubscription.percentageTransactionCharge} % per transaction`
                : ` ${monthlySubscription.symbol} ${monthlySubscription.fixedTransactionCharge} per transaction`)}
          </p>
        )}
        {offer.subscriptionType !== "PER_TRANSACTION" &&
          monthlySubscription && (
            <p className="price">
              {monthlySubscription.price
                ? `${monthlySubscription.symbol}${currency(
                    monthlySubscription.price
                  )}`
                : 0}
            </p>
          )}
        {(offer.subscriptionType == "PERIODIC" ||
          offer.subscriptionType == "PER_USER") &&
          monthlySubscription && (
            <p className="sub-type text-lowercase">
              per user/{monthlySubscription.period}
            </p>
          )}
        {offer.subscriptionType == "ONE_OFF" && (
          <p className="sub-type"> One Off</p>
        )}
        {/* <p className="sub-type">
        {offer.subscriptionType === "PER_USER"
          ? `${properties.minUserLicense} `
          : "Up "}
        to {` ${properties.maxUserLicense} `} Users |{" "}
        {properties ? properties.maxStorage : 0}GB
      </p> */}
        {offer && (
          <Link
            href={{
              pathname: "/subscribe",
              query: {
                offer: offer.token,
                trial: offer.hasTrial,
                isBundle: offer.groupId ? true : false,
              },
            }}
            passHref
          >
            <a className="cicod-btn cicod-btn-blue">
              {" "}
              {offer.hasTrial ? "Try now" : "Sign up now"}
            </a>
          </Link>
        )}
        {/* {!changePlan && (
        <Link
          href={{
            pathname: "/enterprise/subscribe",
            query: { offer: offer.token, product }
          }}
          passHref>
          <a className="cicod-btn cicod-btn-outline red ">Sign up</a>
        </Link>
      )} */}
        {/* {changePlan && selectedOffer == offer.token && (
        <span className="cicod-link--red text">CURRENT PLAN</span>
      )}
      {changePlan && selectedOffer !== offer.token && (
        <Link
          href={{
            query: {
              offer: offer.token,
              product,
              trial: trial ? trial : false,
            },
          }}
          passHref
        >
          <a className="cicod-btn cicod-btn-red">Select</a>
        </Link>
      )} */}
      </div>
    </th>
  );
};

const TableFeaturesMark = ({ offer, featuresIndex, allServiceFeatures }) => {
  let features = offer ? offer.modules : null;
  const featuredClass = offer.isRecommended ? "featured" : "";
  const borderBottomClass =
    allServiceFeatures &&
    offer.isRecommended &&
    featuresIndex == allServiceFeatures.length - 1
      ? "border-bottom"
      : "";
  features = features.sort(sortByName);
  const isEqual = (a, b) => {
    let aName = [];
    let bName = [];
    if (a) {
      a.forEach((element) => {
        aName.push(element.name);
      });
    }
    if (b) {
      b.forEach((element) => {
        bName.push(element.name);
      });
    }
    return bName.includes(aName[featuresIndex]);
  };
  const marked = isEqual(allServiceFeatures, features);
  return (
    <>
      <td className={`text-center marker`}>
        {marked && (
          <img src="/static/img/icons/checkmark-circle-outline.svg" alt="" />
        )}
        {!marked && (
          <img src="/static/img/icons/close-circle-outline.svg" alt="" />
        )}
      </td>
    </>
  );
};
export default Table;
